import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { concatWithDot } from 'helpers/string';

import { calendarPlanInitialValues, ICalendarPlanFormValuesType } from '../Sections/CalendarPlanForm/utils/form';
import {
  fundingDirectionsInitialValues,
  IFundingDirectionsFormValuesType,
} from '../Sections/FundingDirectionsForm/utils/form';
import {
  ILoanRepaymentScheduleFormValuesType,
  loanRepaymentScheduleInitialValues,
} from '../Sections/LoanRepaymentScheduleForm/utils/form';

export const FIRST_COLUMN_WIDTH = 178;

export const CASH_FLOW_ELEMENTS_FORM_NAMES = {
  CALENDAR_PLAN: 'calendarPlan',
  FUNDING_DIRECTIONS: 'fundingDirections',
  LOAN_REPAYMENT_SCHEDULE: 'loanRepaymentSchedule',
} as const;

export const cashFlowElementsPrefix = concatWithDot(
  BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN,
  BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.CASH_FLOW_ELEMENTS,
);

export const calendarPlanPrefix = concatWithDot(cashFlowElementsPrefix, CASH_FLOW_ELEMENTS_FORM_NAMES.CALENDAR_PLAN);
export const fundingDirectionsPrefix = concatWithDot(
  cashFlowElementsPrefix,
  CASH_FLOW_ELEMENTS_FORM_NAMES.FUNDING_DIRECTIONS,
);
export const loanRepaymentSchedulePrefix = concatWithDot(
  cashFlowElementsPrefix,
  CASH_FLOW_ELEMENTS_FORM_NAMES.LOAN_REPAYMENT_SCHEDULE,
);

export interface ICashFlowElements {
  [CASH_FLOW_ELEMENTS_FORM_NAMES.CALENDAR_PLAN]: ICalendarPlanFormValuesType;
  [CASH_FLOW_ELEMENTS_FORM_NAMES.LOAN_REPAYMENT_SCHEDULE]: ILoanRepaymentScheduleFormValuesType;
  [CASH_FLOW_ELEMENTS_FORM_NAMES.FUNDING_DIRECTIONS]: IFundingDirectionsFormValuesType;
}

export const cashFlowElementsInitialValues = {
  [CASH_FLOW_ELEMENTS_FORM_NAMES.CALENDAR_PLAN]: calendarPlanInitialValues,
  [CASH_FLOW_ELEMENTS_FORM_NAMES.LOAN_REPAYMENT_SCHEDULE]: loanRepaymentScheduleInitialValues,
  [CASH_FLOW_ELEMENTS_FORM_NAMES.FUNDING_DIRECTIONS]: fundingDirectionsInitialValues,
};

export const DEFAULT_DEBOUNCE_TIME_CASH_FLOW_ELEMENTS = 500;
